import {css} from '@emotion/react';
import styled from '@emotion/styled';

type Props = {
  backgroundImageUrl: string;
};

export const Container = styled.div<Props>(
  ({theme, backgroundImageUrl}) => css`
    position: relative;
    height: 270px;
    background:
      no-repeat bottom center/cover url('${backgroundImageUrl}'),
      ${theme.colors.backgroundStateDisabled};
    padding: 0 16px;

    &:before {
      content: '';
      position: absolute;
      inset: 0;
      background-color: #222222;
      opacity: 0.2;
    }

    ${theme.respondTo(
      'lg',
      css`
        height: 375px;
      `
    )};
  `
);
